export const DEFAULT_LABEL_COLOR = "#6A1262";
